<template>
  <div class="nav-main">
    <v-toolbar
      style="position:fixed"
      color="#A7C84B"
      elevation="1"
      absolute
      width="100%"
    >
      <v-toolbar-title @click="routingInicio()">
        <v-img
          src="@/assets/ObiPetsLogo.svg"
          class="my-3"
          contain
          height="50"
        />
      </v-toolbar-title>

      <v-col class="d-none d-md-flex">
        <a
          style="text-decoration:none;"
          href="https://www.facebook.com/ObiPets/"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-facebook</v-icon>
        </a>
        <a
          style="text-decoration:none;"
          href="https://www.instagram.com/obipets/"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-instagram</v-icon>
        </a>

        <a
          style="text-decoration:none;"
          href="https://wa.me/message/5XW7W2ZLGPAHP1"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-whatsapp</v-icon>
        </a>

        <a
          style="text-decoration:none;"
          href="https://www.youtube.com/channel/UCApVVqnvVjf81dXA9o5Woeg"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-youtube</v-icon>
        </a>

        <a
          style="text-decoration:none;"
          href="https://www.pinterest.com.mx/obipets/"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-pinterest</v-icon>
        </a>

        <a
          style="text-decoration:none;"
          href="https://t.me/ObiPets"
          target="_blank"
        >
          <v-icon color="orange darken-3" class="mx-1">mdi-telegram</v-icon>
        </a>
      </v-col>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-row>
          <v-col>
            <v-btn
              rounded=""
              style="text-transform:none;"
              color="#A7C84B"
              elevation="0"
              :outlined="true"
              href="https://obipets.myshopify.com/"
            >
              <span style="color:#fff;font-family: 'Kaleko', sans-serif;"
                >Inicio</span
              >
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              rounded=""
              style="text-transform:none;"
              color="#A7C84B"
              elevation="0"
              :outlined="true"
              href="https://obipets.myshopify.com/products/placa-obipets"
              target="new"
            >
              <span style="color:#fff;font-family: 'Kaleko', sans-serif;"
                >¡Adquirir Placa!</span
              >
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              rounded
              style="text-transform:none; font-family: 'Kaleko', sans-serif;"
              color="orange darken-1"
              elevation="0"
              to="/registro"
              >Registrarse</v-btn
            >
          </v-col>
        </v-row>

        <div v-if="this.$store.state.auth.name === null">
          <v-row>
            <v-col>
              <v-btn
                rounded
                style="text-transform:none; font-family: 'Kaleko', sans-serif;"
                color="orange darken-1"
                elevation="0"
                to="login"
                >Iniciar Sesión</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row>
            <v-col>
              <v-btn
                rounded
                style="text-transform:none;font-family: 'Kaleko', sans-serif;"
                color="#FB8C00"
                elevation="0"
                @click="_logout"
              >
                <span style="color:#fff;">Cerrar Sesión</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-toolbar-items>
      <v-btn
        sm
        color="#A7C84B"
        class="d-md-none"
        elevation="0"
        @click="navigator = true"
      >
        <v-icon color="#fff">mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      class="pointbrake"
      color="#A7C84B"
      clipped
      temporary
      v-model="navigator"
      app
      right
      mobile-break-point
    >
      <v-list style="margin-top:35px">
        <v-list-item>
          <v-list-item-title @click="routingInicio()">
            <v-img
              src="@/assets/ObiPetsLogo.svg"
              class="my-3"
              contain
              height="100"
            />
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <v-btn
              rounded=""
              style="text-transform:none;"
              color="#A7C84B"
              elevation="0"
              :outlined="true"
              href="https://obipets.myshopify.com/"
              target="new"
            >
              <span style="color:#fff;font-family: 'Kaleko', sans-serif;"
                >Inicio</span
              >
            </v-btn>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-btn
              rounded=""
              style="text-transform:none;"
              color="#A7C84B"
              elevation="0"
              href="https://obipets.myshopify.com/products/placa-obipets"
            >
              <span
                style="color:#fff; font-weight:300 ;font-family: 'Kaleko', sans-serif;"
                >¡Adquirir Placa!</span
              >
            </v-btn>
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>
            <v-btn
              rounded
              style="text-transform:none; font-family: 'Kaleko', sans-serif;"
              color="orange darken-1"
              elevation="0"
              to="/registro"
            >
              <span style="color:#fff">Registrarse</span>
            </v-btn>
          </v-list-item-title>
        </v-list-item>
        <!--   <v-list-item v-if="this.$store.state.auth.isObipetsAdmin === true">
          <v-list-item-title>
            <v-btn
              style="text-transform:none;color:#fff;font-family: 'Kaleko', sans-serif;"
              color="#A7C84B"
              elevation="0"
              to="/dashboard/admin"
              >Ir a Panel</v-btn
            >
          </v-list-item-title>
        </v-list-item> -->
        <!--  <v-list-item v-else-if="this.$store.state.auth.name !== null">
          <v-list-item-title>
            <v-btn
              style="text-transform:none;color:#fff;font-family: 'Kaleko', sans-serif;"
              color="#A7C84B"
              elevation="0"
              to="/dashboard/usuario"
              >Ir a Panel</v-btn
            >
          </v-list-item-title>
        </v-list-item> -->
        <v-spacer></v-spacer>
        <v-container class="text-center">
          <v-list-item v-if="this.$store.state.auth.name === null">
            <v-list-item-title>
              <v-btn
                to="login"
                rounded
                style="text-transform:none; font-family: 'Kaleko', sans-serif;"
                color="orange darken-1"
                elevation="0"
              >
                <span style="color:#fff">Iniciar Sesión</span>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-title>
              <v-btn
                rounded
                style="text-transform:none;font-family: 'Kaleko', sans-serif;"
                color="#FB8C00"
                elevation="0"
                @click="_logout"
              >
                <span style="color:#fff;">Cerrar Sesión</span>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-container class="text-center">
            <h3 style="color:#fff;font-family: 'Kaleko', sans-serif;">
              Siguenos
            </h3>
            <v-col>
              <a
                style="text-decoration:none;"
                href="https://www.facebook.com/ObiPets/"
                target="_blank"
              >
                <v-icon size="x-large" color="orange darken-3" class="mx-2"
                  >mdi-facebook</v-icon
                >
              </a>
              <a
                style="text-decoration:none;"
                href="https://www.instagram.com/obipets/"
                target="_blank"
              >
                <v-icon size="x-large" color="orange darken-3" class="mx-2"
                  >mdi-instagram</v-icon
                >
              </a>
              <a
                style="text-decoration:none;"
                href="https://wa.me/message/5XW7W2ZLGPAHP1"
                target="_blank"
              >
                <v-icon color="orange darken-3" class="mx-1"
                  >mdi-whatsapp</v-icon
                >
              </a>

              <a
                style="text-decoration:none;"
                href="https://www.youtube.com/channel/UCApVVqnvVjf81dXA9o5Woeg"
                target="_blank"
              >
                <v-icon color="orange darken-3" class="mx-1"
                  >mdi-youtube</v-icon
                >
              </a>

              <a
                style="text-decoration:none;"
                href="https://www.pinterest.com.mx/obipets/"
                target="_blank"
              >
                <v-icon color="orange darken-3" class="mx-1"
                  >mdi-pinterest</v-icon
                >
              </a>

              <a
                style="text-decoration:none;"
                href="https://t.me/ObiPets"
                target="_blank"
              >
                <v-icon color="orange darken-3" class="mx-1"
                  >mdi-telegram</v-icon
                >
              </a>
            </v-col>
            <a style="text-decoration:none;" href="mailto:hola@obipets.com.mx">
              <v-icon color="orange darken-3" class="mx-1">mdi-email</v-icon>
              <p style="color:#fff;font-family: 'Kaleko', sans-serif;">
                hola@obipets.com.mx
              </p>
            </a>
          </v-container>
        </v-container>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      navigator: false,
      offset: true,
    };
  },
  methods: {
    ...mapActions("auth", { logout: "logout" }),
    _logout() {
      this.logout();
      this.$router
        .push({
          name: "login",
        })
        .catch(() => {});
    },
    menuItems() {
      return this.menu;
    },
    internalLink(link) {
      if (this.$route.name !== "landingPage") {
        if (window.innerWidth < 968) {
          location.href = "/" + link;
        } else {
          this.$router.push({
            path: `/${link}`,
          });
        }
      } else {
        this.navigator = false;
        this.$vuetify.goTo(link, {
          duration: 400,
          offset: 0,
          easing: "easeInOutCubic",
        });
      }
    },
    routingInicio() {
      location.href = "https://obipets.myshopify.com/";
    },
  },
};
</script>

<style lang="scss" scoped>
.pointbrake {
  display: block;
  @media only screen and (min-width: 1000px) {
    display: none;
  }
}
.v-list-item {
  text-align: center;
}
.v-application a {
  text-decoration: none;
  text-align: center;
  color: #f2f2f2;
}
.v-list[data-v-6f921cac] {
  background-color: #a7c84b;
  max-width: 100% !important;
}
</style>
